import React, { useState, useEffect } from "react";
import BookingDropdown from "./BookingDropdown";

const FloatingCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12 pointer-events-none"
      }`}
    >
      <BookingDropdown
        triggerLabel="Book Now"
        dropUp
        align="right"
        triggerClassName="flex items-center gap-2 bg-stables-600 hover:bg-stables-700 text-white pl-5 pr-4 py-3 rounded-full shadow-2xl shadow-stables-800/40 transition-all duration-300 hover:scale-105 font-semibold text-sm"
      />
    </div>
  );
};

export default FloatingCTA;
